import React, { PureComponent } from 'react';
import { string, number, bool, shape } from 'prop-types';
import { logger } from '@fiverr-private/perseus';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafeComponent from '../shared/SafeComponent';
import Context from '../../utils/context';
import getRecommendationsData from '../../utils/getRecommendationsData';
import GigCarouselWrapper from '../shared/GigCarouselWrapper';
import { getGigIds } from '../../utils/browsingHistory';
import { INSPIRED_BY_VIEWS, MINIMUM_ITEMS } from '../../utils/constants/recommendations';

const buildAjaxQueryParams = () => {
    const gigIds = getGigIds();
    if (!gigIds.length) {
        return;
    }

    return { gig_ids: gigIds, type: INSPIRED_BY_VIEWS };
};

class InspiredByRecentViews extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            gigs: [],
            isLoading: true
        };

        this.fetchRecommendations = this.fetchRecommendations.bind(this);
    }

    componentDidMount() {
        this.fetchRecommendations();
    }

    hasMinimumItems(){
        const { gigs } = this.state;

        return gigs && gigs.length >= MINIMUM_ITEMS;
    }

    fetchRecommendations() {
        const queryParams = buildAjaxQueryParams();
        if (!queryParams) {
            this.setState({
                isLoading: false
            });
            logger.warn({message: 'Empty gigs in local storage'});
            return;
        }

        getRecommendationsData(queryParams)
            .then((result) => {
                const { gigs, gigCollect } = result;

                this.setState({
                    gigs,
                    gigCollect,
                    isLoading: false
                });
            })
            .catch(() => {
                this.setState({
                    isLoading: false
                });
            });
    }

    hasSufficientCookies() {
        const { lastGigInCookie, userWasLoggedIn } = this.props;

        return !!lastGigInCookie && !userWasLoggedIn;
    }

    shouldRenderCarousel() {
        const { isLoading } = this.state;

        return this.hasSufficientCookies() &&
            (this.hasMinimumItems() || (!this.hasMinimumItems() && isLoading));
    }

    render() {
        const { isTouch, page_ctx_id, currency } = this.props;
        const { gigs, isLoading, gigCollect } = this.state;

        if (!this.shouldRenderCarousel()) {
            return null;
        }

        return (
            <GigCarouselWrapper gigs={gigs}
                boxClass={INSPIRED_BY_VIEWS}
                boxTitle={<I18n k="logged_out_homepage.recommendations.recently_viewed_and_more.title"/>}
                carouselPosition={1}
                page_ctx_id={page_ctx_id}
                isTouch={isTouch}
                currency={currency}
                isLoading={isLoading}
                gigCollect={gigCollect}/>
        );
    }
}

InspiredByRecentViews.propTypes = {
    page_ctx_id: string,
    currency: shape({
        name: string,
        rate: number,
        template: string,
        forceRound: bool,
        forceRoundFromAmount: number
    }),
    isTouch: bool,
    lastGigInCookie: number,
    userWasLoggedIn: bool
};

const InspiredByRecentViewsWithContext = ({ isTouch }) => (
    <Context.Consumer>
        {({page_ctx_id, currency, last_gig_in_cookie, user_was_logged_in}) => (
            <InspiredByRecentViews currency={currency}
                isTouch={isTouch}
                page_ctx_id={page_ctx_id}
                lastGigInCookie={last_gig_in_cookie}
                userWasLoggedIn={user_was_logged_in}/>
        )}
    </Context.Consumer>
);

export { InspiredByRecentViews };
export default SafeComponent(InspiredByRecentViewsWithContext);
